export default function withInitStateReducerEnhancer(reducer, initState) {
  let initialState;
  return (state, action, ...otherArgs) => {
    if (!state && !initialState) {
      initialState = initState();
    }
    return reducer(state || initialState, action, ...otherArgs);
  };
}
